import {readRecord,writeRecord,deleteRecord} from './studio-storage.js';
import {normalizeDesign} from './design-model.js';
const SESSION_KEY='minimural:cart-edit-session';
let queue=Promise.resolve();
const serial=operation=>{const next=queue.then(operation);queue=next.catch(()=>{});return next;};
function activeKey(){try{const key=sessionStorage.getItem(SESSION_KEY);return /^cart-edit-[a-f0-9-]{36}$/.test(key||'')?key:null;}catch{return null;}}
export async function beginCartEditSession({id,returnTo,originalDraft,design}){
  await clearCartEditSession();
  const key='cart-edit-'+crypto.randomUUID();
  const record={id,returnTo:['cart','checkout','modal'].includes(returnTo)?returnTo:'cart',originalDraft:normalizeDesign(originalDraft),design:normalizeDesign(design)};
  await serial(()=>writeRecord(key,record));
  try{sessionStorage.setItem(SESSION_KEY,key);}catch(error){await serial(()=>deleteRecord(key));throw error;}
}
export async function restoreCartEditSession(cart){
  const key=activeKey();if(!key)return null;
  const record=await readRecord(key);
  if(!record||!cart.some(item=>item.id===record.id&&item.kind==='custom')||record.design?.nails?.length!==10||record.originalDraft?.nails?.length!==10){await clearCartEditSession();throw new Error('编辑记录不完整或原商品已移除，已结束编辑。购物袋中的设计保持不变。');}
  return {...record,returnTo:['cart','checkout','modal'].includes(record.returnTo)?record.returnTo:'cart',originalDraft:normalizeDesign(record.originalDraft),design:normalizeDesign(record.design)};
}
export function saveCartEditProgress(design){
  const key=activeKey();if(!key)return Promise.resolve();
  const snapshot=normalizeDesign(design);
  return serial(async()=>{const record=await readRecord(key);if(record)await writeRecord(key,{...record,design:snapshot});});
}
export function clearCartEditSession(){
  const key=activeKey();try{sessionStorage.removeItem(SESSION_KEY);}catch{}
  return key?serial(()=>deleteRecord(key)):Promise.resolve();
}